import {
  createAction,
  createEntityAdapter,
  createReducer,
  EntityState,
} from "@reduxjs/toolkit";

import { CardPaymentBody, CashPaymentBody } from "api/payment";
import { RootState } from "store";

export interface PaymentCardData extends CardPaymentBody {
  id: string;
}
export interface PaymentCashData extends CashPaymentBody {
  id: string;
}

export type PaymentData = PaymentCardData | PaymentCashData;

export const restorePaymentData = createAction<Array<PaymentData>>(
  "productPayment/restorePaymentData"
);
export const savePaymentData = createAction<PaymentData>(
  "productPayment/savePaymentData"
);
export const clearPaymentData = createAction("productPayment/clearPaymentData");

const paymentEntities = createEntityAdapter<PaymentData>({
  selectId: (item) => item.id,
});

export interface PaymentState extends EntityState<PaymentData> {}

const initialState: PaymentState = paymentEntities.getInitialState();

export const paymentReducer = createReducer(initialState, (builder) => {
  builder.addCase(restorePaymentData, (state, action) => {
    paymentEntities.addMany(state, action.payload);
  });
  builder.addCase(savePaymentData, (state, action) => {
    paymentEntities.addOne(state, action.payload);
  });
  builder.addCase(clearPaymentData, (state) => {
    paymentEntities.removeAll(state);
  });
});

export const getPaymentState = (state: RootState): PaymentState =>
  state.productPayment.payment;
export const getEntities = (state: RootState) =>
  getPaymentState(state).entities;
export const getPaymentDataList = (state: RootState) =>
  Object.values(getEntities(state)) as PaymentData[];
export const getPaymentDataById = (state: RootState, props: { id: string }) =>
  getEntities(state)[props.id];
